var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBottomNavLoadIconMobActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.035 0L.381 3.84l6.654 3.735 6.245-3.734L7.035 0zM0 12.159l6.673 3.84V8.207L0 4.472v7.687zM13.743 4.381L7.398 8.204V16l6.654-3.84-.31-7.779z",
    fill: "#2355FC"
  })));
}

export default SvgBottomNavLoadIconMobActive;